import { ITestimonial } from '@gik/core/models/gik/ITestimonial';
import Masha from '@gik/core/assets/img/avatars/avatar-masha.svg';
import Amy from '@gik/core/assets/img/avatars/avatar-amy.svg';
import Lexi from '@gik/core/assets/img/avatars/avatar-lexi.svg';
import Keri from '@gik/core/assets/img/avatars/avatar-keri.svg';

// TODO: add `quote` and `title` to i18n

export const LexiTestimonial: ITestimonial = {
  name: 'Lexi S.',
  quote:
    'Thank you for creating something so amazingly helpful to use in such a difficult time. It’s going to help so much',
  title: 'Give InKind User',
  avatar: Lexi,
  location: 'Buckeye, AZ',
};

export const AmieTestimonial: ITestimonial = {
  name: 'Amie L.',
  quote: 'My treatments may have healed my cancer, but Give InKind saved my family in every other aspect.',
  title: 'Give InKind User',
  avatar: Amy,
  location: ' Windsor, CA',
};

export const MashaTestimonial: ITestimonial = {
  name: 'Masha C.',
  quote: 'We are in awe of how quickly our hospital meal effort has grown. Thank you for your amazing platform!',
  title: 'Organizer during COVID-19',
  avatar: Masha,
  location: 'Chicago, IL',
};

export const KeriTestimonial: ITestimonial = {
  name: 'Keri M. W.',
  quote:
    "Our friends set up a meal schedule for us. This is an easier way to provide help to us while we're adjusting.",
  title: 'New Mom',
  avatar: Keri,
  location: 'Knoxville, TX',
};

export const testimonials: ITestimonial[] = [LexiTestimonial, AmieTestimonial, MashaTestimonial, KeriTestimonial];
